import { render, staticRenderFns } from "./ModalLogin.vue?vue&type=template&id=546130bc&"
import script from "./ModalLogin.vue?vue&type=script&lang=js&"
export * from "./ModalLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports